import React from 'react';
import SearchBar from 'src/modules/search/shared/components/searchBar';
import classNames from 'classnames';

const SearchBox = ({ title, placeholder, isCommunitySearch, isMobile }) => {
  const classes = classNames({
    'search-box': true,
    'search-box__mobile': !!isMobile,
  });

  const customId = isMobile ? 'search-bar-mobile' : 'search-bar';

  return (
    <div className={classes}>
      {!!title &&
        <h2 className="search-box__header">
          {title}
        </h2>
      }
      <div className="search-box__search-bar">
        <SearchBar
          customId={customId}
          isCommunitySearch={isCommunitySearch}
          placeholderText={placeholder}
          reloadPage={true}
        />
      </div>
    </div>
  );
};

export default SearchBox;
